module.exports = __webpack_public_path__ + "static/media/250221_LD-2025203A_LP0DZC0002.51dc8309.pdf";